import { Colors, Lightning, Router, Utils } from '@lightningjs/sdk'
import AlbumCover from '../components/coverItems/AlbumCover'
import EpisodeItem from '../components/coverItems/EpisodeItem'
import EpisodeList from '../components/lists/EpisodeList'
import { appSettings } from '../lib/AppSettings'
import ImageItemWrapper from '../lib/ui/helpers/ImageItemWrapper'

export default class Episodes extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('PageBG').get(),
      // BlurWpr: {
      // 	type: Lightning.components.FastBlurComponent,
      // 	amount: 3,
      // 	w: 1920,
      // 	h: 1080,
      // },
      // BackGrd: {w: 1920, h: 1080 },
      // Shade: {w: 1920, h: 1080, rect: true, alpha: 0.30, color: 0xff343434},
      Album: { w: 540, h: 540, x: 260, y: 117, type: AlbumCover },
      AlbumInfo: {
        w: 543,
        h: 400,
        x: 260,
        y: 677,
        Name: {
          w: 543,
          h: 90,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('name'),
            textAlign: 'left',
            fontSize: 35,
            fontFace: 'OpenSansbold',
            MaxLines: 2,
            lineHeight: 45,
          },
        },
        Brand: {
          w: 543,
          h: 40,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('schedule'),
            textAlign: 'left',
            fontSize: 25,
            fontFace: 'OpenSansRegular',
            lineHeight: 35,
          },
        },
        Description: {
          w: 543,
          h: 265,
          color: Colors('white').get(),
          text: { text: this.bindProp('descr'), textAlign: 'left', fontSize: 28, lineHeight: 40 },
        },
      },
      EpisodesList: {
        x: 968,
        y: 116,
        w: 800,
        h: 915,
        type: EpisodeList,
        direction: 'vertical',
        autoResize: false,
        spacing: 40,
        scrollOffset: 40,
        scrollTransition: { duration: 0.6, timingFunction: 'cubic-bezier(.2,0,0,1.015)' },
        signals: { indexChanged: true },
      },
    }
  }

  set items(episodesData) {
    this._dataSet = episodesData
    this._items = episodesData.playlists

    if (episodesData) {
      if (episodesData.dataType === 'catchUp') {
        this._buildCatchup()
      } else {
        this._buildPodcast()
      }
    } else {
      this.noData = true
    }
  }
  historyState(params) {
    if (params) {
      if (params.mainIndex) {
        this.tag('EpisodesList').index = params.mainIndex
      }
    } else {
      return {
        mainIndex: this.tag('EpisodesList').index,
      }
    }
  }
  playbackError() {
    this.widgets.errorbox.alpha = 1
    this.widgets.errorbox.notify({ type: 'playbackStopped', Notification: true })
    Router.focusWidget('ErrorBox')
  }

  pageTransition() {
    return 'fade'
  }

  _init() {
    this._setState('Idle')
    this.tag('Name').on('txLoaded', () => {
      this.tag('Brand').y = this.tag('Name').finalH + 20
    })
    this.tag('Brand').on('txLoaded', () => {
      this.tag('Description').y = this.tag('Brand').y + this.tag('Brand').finalH + 20
    })
  }

  _buildCatchup() {
    this._brand = appSettings.currentBrand

    // this.tag('BackGrd').texture = Img(this._brand.background, { w: 1920, h: 1080, type: 'cover' });
    // this.tag('BlurWpr').content = {w: 1920, h: 1080, texture: Img(this._brand.background, { w: 1920, h: 1080, type: 'cover' })};

    this.tag('Album').item = this._dataSet.data.imageUrl
    this.tag('Album').itemBg = this._brand.background
      ? this._brand.background
      : Utils.asset('images/covers/ImagePlaceHolder.jpg')
    // this.tag('Album').itemBg = this._dataSet.brandName ? itemBackgroundUrl(this._dataSet.brandName): Utils.asset('images/covers/ImagePlaceHolder.jpg');

    const { title, description } = this._dataSet.data

    this.patch({
      name: title,
      descr: description,
      schedule: this._brand.name,
    })

    this.tag('EpisodesList').items = this._dataSet.data.episodes.map((eps, idx) => {
      return {
        ref: `Episode-${eps.id}`,
        w: 800,
        h: idx === 0 ? 320 : 195,
        sizes: { h1: 195, h2: 320 },
        type: ImageItemWrapper,
        itemType: EpisodeItem,
        item: eps,
        bgImage: this._brand.background,
      }
    })

    this.tag('EpisodesList').availableItems = this._dataSet.data.episodes.length
  }

  _active() {
    this.mnuIdx = this._dataSet.dataType === 'catchUp' ? 1 : 3

    this.widgets['sidemenu'].activeMenuItem = this.mnuIdx
  }
  _inactive() {
    this.stage.gc()
  }

  _focus() {
    this.tag('EpisodesList')._reposition()
    this._setState('EpisodesList')
  }

  static _states() {
    return [
      class Idle extends this {
        _handleLeft() {
          Router.focusWidget('SideMenu')
        }
      },

      class EpisodesList extends this {
        $enter() {
          if (this.tag('EpisodesList').items.length > 0) {
            this.tag('EpisodesList')._reposition()
          } else {
            this._setState('Idle')
          }
        }
        $exit() {
          if (this.tag('EpisodesList').items.length > 0) {
            this.tag('EpisodesList').unfocusList()
          } else {
            this._setState('Idle')
          }
        }

        _handleLeft() {
          // this.tag("EpisodesList").episodeItem(this.tag("EpisodesList").index).child._showLargeSmall(false);
          this.tag('EpisodesList').unfocusList()
          Router.focusWidget('SideMenu')
        }

        _handleEnter() {
          const id = this.tag('EpisodesList').episodeId

          Router.navigate(`catchupDetails/${this._dataSet.dataId}/${id}`, { autoPlay: false })
        }

        _getFocused() {
          return this.tag('EpisodesList')
        }
      },
    ]
  }
}
